class SpeechBubbleCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.color = options?.color ? false
        @.date = options?.date ? {}
        @.own = options.own ? false
        @.tag = options?.tag ? 'div'
        @.textContent = options?.textContent ? ''
        @.username = options?.username ? 'n/a'


        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'speech-bubble'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.color
            @.$el.classList.add "speech-bubble--#{ @.color }"
        if @.own
            @.$el.classList.add "speech-bubble--own"
        @.$el.innerHTML = "
            <div class='speech-bubble__head'>
                <div class='speech-bubble__username'>#{ @.username }</div>
                <div class='speech-bubble__date'>
                    <div class='kicker speech-bubble__date__day'>#{ @.date.day ? "n/a" }</div>
                    <div class='speech-bubble__date__time'>#{ @.date.time ? "n/a" }</div>
                </div>
            </div>
        "
        @.$el.appendChild window.CreateRichtext {
            attrs: {
                class: ['speech-bubble__content']
            }
            textContent: @.textContent
        }
        return

window.CreateSpeechBubble = (options) ->
    return new SpeechBubbleCreate options